
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import User from '@/extend/classes/User';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeUser' })

export default class storeUser extends VuexModule {
  // States
  private reccords: User[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get userLoading (): boolean {
    return this.dataLoading;
  }
  private get userRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get userLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewUser() {
    return (): User => { 
      return this.getUser(0, true);
    }
  }

  
  public get getUser () {
    return (id: number, canCreate = false): User => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id User can't be 0")
        return new User();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new User();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            User.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromUser(data.reccords[0] as User);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listUser (): User[] {
    return this.reccords;
  }

  public get listConfigUser (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mUserRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mUserClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mUserLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mUserLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(User.fromJson(reccord as User));
    })
    User.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mUserConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mUserCreated (obj: User): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareUser(obj)) {
          api.fromUser(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareUser(obj)) {
            api.fromUser(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mUserUpdated (obj: User): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareUser(obj)) {
          api.fromUser(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mUserDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerUser (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.userRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerUser(this.userCreated, this.userUpdated, this.userDeleted);
          this.mUserRegistered();
        } else {
          setTimeout(() => resolve(this.registerUser(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.userLoading && !this.userLoaded) {
          this.mUserLoading(true);
          return User.list(filter)
            .then((data: ListData) => {
              this.mUserLoaded(data);
              this.mUserLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredUser (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.userLoading) {
        this.mUserLoading(true);
        return User.list(filter)
          .then((data: ListData) => {
            this.mUserLoaded(data);
            this.mUserLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createUser (obj: User): Promise<User> {
    return new Promise((resolve, reject) => {
      return User.fromJson(obj).createForStoreUser()
        .then((reccords) => {
          this.mUserCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updateUser (obj: User): Promise<User> {
    return new Promise((resolve, reject) => {
      return User.fromJson(obj).updateForStoreUser()
        .then((reccords) => {
          this.mUserUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  public deleteUser (obj: User): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return User.fromJson(obj).deleteForStoreUser()
        .then(() => {
          if (!storeSession.hubUsed) {
            this.mUserDeleted(obj.id);
          }
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private userCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mUserConfigUpdated(config)
    const obj = objConfig.obj as User;
    this.mUserCreated(User.fromJson(obj));
  }

  @Action
  private userUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mUserConfigUpdated(config)
    const obj = objConfig.obj as User;
    this.mUserUpdated(User.fromJson(obj));
  }

  @Action
  private userDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as User;
    this.mUserDeleted(obj.id);
  }
}
